"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultApiErrorTranslator = exports.cognitoErrorTranslator = void 0;
var _api = require("@focaltec-suite/api");
var _Translator = _interopRequireDefault(require("./Translator"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var defaultApiErrorTranslator = exports.defaultApiErrorTranslator = function defaultApiErrorTranslator(apiError, data) {
  var _a, _b, _c;
  var resource = (_b = (_a = apiError.resource) !== null && _a !== void 0 ? _a : data['microservice']) !== null && _b !== void 0 ? _b : '';
  if (resource === 'workflove') {
    var values = Object.values((_c = apiError.metadata) !== null && _c !== void 0 ? _c : {});
    if ((apiError.code === 2006 || apiError.code === 2007) && values.length >= 1) {
      return (0, _Translator["default"])("errors.workflove.hard.".concat(apiError.code), {
        fieldName: values[0]
      });
    }
    if (apiError.code === 2008) {
      return (0, _Translator["default"])("errors.workflove.".concat(apiError.code));
    }
    return apiError.description;
  }
  return (0, _Translator["default"])("errors".concat(resource ? ".".concat(resource) : '', ".").concat(apiError.code), data);
};
var cognitoErrorTranslator = exports.cognitoErrorTranslator = function cognitoErrorTranslator(error, consumer) {
  if (error instanceof _api.CognitoError) {
    consumer((0, _Translator["default"])("errors.cognito.".concat(error.message)));
  } else {
    consumer(error.message);
  }
};